import List from "./List";

const routes = [
    {
        path: 'stores',
        element: <List />
    }
]
export default routes;